module.exports = require("./se.d.ts");